import { Box, Typography } from "@mui/material";
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    LabelList,
    ReferenceArea
} from "recharts";

const data = [
    { year: 2008, value: 4.5 },
    { year: 2009, value: 4.5 },
    { year: 2010, value: 4.4 },
    { year: 2011, value: 4.4 },
    { year: 2012, value: 4.8 },
    { year: 2013, value: 4.9 },
    { year: 2014, value: 4.8 },
    { year: 2015, value: 4.9 },
    { year: 2016, value: 5.1 },
    { year: 2017, value: 5.2 },
    { year: 2018, value: 5.0 },
    { year: 2019, value: 5.5 },
    { year: 2020, value: 5.6 },
    { year: 2021, value: 5.9 },
    { year: 2022, value: 7.0 },
    { year: 2023, value: 7.2 },
    { year: 2024, value: 8.3 },
    { year: 2025, value: 7.5 },
];

const Tract3G1: React.FC = () => {
    return (
        <Box sx={{ position: "relative", height: 260 }}>
            {/* Graphique Recharts */}
            <ResponsiveContainer width="100%" height="100%">
                <BarChart
                    data={data}
                    margin={{ top: 40, right: 20, left: 20, bottom: 20 }}
                >
                    <CartesianGrid strokeDasharray="3 3" opacity={0.2} />
                    <XAxis dataKey="year" />
                    <YAxis domain={[4, 9]} />
                    <Tooltip formatter={(v) => `${v} M€`} />

                    {/* Zone du maire actuel */}
                    <ReferenceArea
                        x1={2018}
                        x2={2025}
                        fill="#e5e0ff"
                        fillOpacity={0.9}
                    />

                    {/* Barres de dépenses */}
                    <Bar dataKey="value" fill="#fbc02d" radius={[4, 4, 0, 0]}>
                        <LabelList dataKey="value" position="top" />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>

            {/* Overlay : "M. Dintilhac maire" */}
            <Box
                sx={{
                    position: "absolute",
                    top: 8,
                    left: "60%",     // ajuste si besoin
                    px: 1,
                    py: 0.3,
                    bgcolor: "rgba(255,255,255,0.9)",
                    borderRadius: 1,
                }}
            >
                <Typography
                    variant="caption"
                    sx={{ fontWeight: 600, color: "#444" }}
                >
                    M. Dintilhac maire
                </Typography>
            </Box>

            {/* Overlay : pastille +49% */}
            <Box
                sx={{
                    position: "absolute",
                    top: 36,
                    left: "70%",      // ajuste si besoin
                    px: 1.6,
                    py: 0.4,
                    bgcolor: "#b71c1c",
                    borderRadius: 999,
                    color: "#fff",
                    fontSize: 12,
                    fontWeight: 700,
                }}
            >
                +49%
            </Box>

            {/* Overlay : pastille +8% (2008-2013) */}
            <Box
                sx={{
                    position: "absolute",
                    top: 32,
                    left: "20%",      // ajuste pour centrer entre 2008 et 2013
                    px: 1.6,
                    py: 0.3,
                    bgcolor: "#fff",
                    borderRadius: 999,
                    border: "1px solid #555",
                    fontSize: 12,
                    fontWeight: 700,
                    color: "#444",
                }}
            >
                +8%
            </Box>

            {/* Overlay : pastille +8% (2014-2017) */}
            <Box
                sx={{
                    position: "absolute",
                    top: 48,
                    left: "42%",      // ajuste pour centrer entre 2014 et 2017
                    px: 1.6,
                    py: 0.3,
                    bgcolor: "#fff",
                    borderRadius: 999,
                    border: "1px solid #555",
                    fontSize: 12,
                    fontWeight: 700,
                    color: "#444",
                }}
            >
                +8%
            </Box>
        </Box>
    );
};

export default Tract3G1;
